export const routes: Record<string, readonly string[]> = {
  requiresAuth: [
    '/account',
    '/account/settings',
    '/account/billing',
    '/account/referrals',
    '/account/keys',
    '/studio',
    '/interactive/participant',
    '/interactive/control',
    '/join',
  ],
  requiresNoAuth: ['/auth', '/auth/callback'],
};

export const pathnames = {
  requiresAuth: (pathname: string) => {
    for (const route of routes.requiresAuth) {
      if (pathname.includes(route)) return true;
    }
    return false;
  },
  requiresNoAuth: (pathname: string) => {
    for (const route of routes.requiresNoAuth) {
      if (pathname.includes(route)) return true;
    }
    return false;
  },
};

export const financial = {
  royalty: 5,
  governance: 10,
} as const;

export const COLORS = [
  '#5470C6', // Soft Blue
  '#91CC75', // Light Green
  '#FAC858', // Soft Yellow
  '#EE6666', // Soft Red
  '#73C0DE', // Sky Blue
  '#3BA272', // Teal Green
  '#FC8452', // Warm Orange
  '#9A60B4', // Soft Purple
  '#6DCCFF', // Light Aqua Blue
  '#4DB6AC', // Fresh Green
] as const;
